/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-indent */
import React, { useContext, useRef, useEffect, useMemo, useState, useLayoutEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import cn from 'classnames';
import pt from 'prop-types';
import defaultDpImage from 'Assets/person.svg';
import defaultDpImage_Female from 'Assets/female@2x.png';
import defaultDpImage_Male from 'Assets/male@2x.png';
import PersonIcon from 'Assets/person-profile.svg';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { ReactComponent as DragIcon } from 'Assets/drag.svg';
import newRequestImage from 'Assets/plus@2x.png';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { ReactComponent as RightArrow } from 'Assets/profile-right-arrow.svg';
import { ReactComponent as LeftArrow } from 'Assets/profile-left-arrow.svg';
import AlterImage from 'Assets/alter-image.png';
import {
  Box, Button, ButtonGroup, Typography,
} from '@mui/material';
import {
  Upload, UserPlus, ArrowUpDown, Mic, CreditCard,
} from 'Utils/lucideIcons';
import { EXPLORED_SECTION } from 'Utils/onboardingChecklist';
import { OnboardingChecklist } from 'Pages/private/v2/_shared/OnboardingChecklist';
import SoftAuroraGL from 'Components/reactbits/SoftAuroraGL';
import RowCarousel from 'Components/reactbits/RowCarousel';
import { AppContext, AuthContext } from 'Context';
import { logAppEvent } from 'Api/errorLogger';
import { Pathname } from 'Routes';
import { PromotionModal } from 'Components/upload-modal';
import { MobileModal } from 'Components/mobileViewModal';
import { baseUrl, axios } from 'Api';
import styles from './index.module.css';
import { Page, Snackbar, ConfirmationModal } from '../../../Components';
import ManageProjectorModal from './ManageProjectorModal';

const ProfileLink = ({ setProfileDetails, className, onClick, dpURL, gender, isAccessRequestButton, link, name, display_name,
  isViewMyContent, id, setdataOfCategory, showRemoveProjectorText, setModalTitle, setProjectorImage, setModal, setProjectorOwner, setProjectorName, setProjectorId, removeProjectorText, isBelowAccessButton }) => (
  <div
    onClick={() => {
      setdataOfCategory && setdataOfCategory();
      setProfileDetails && setProfileDetails({
        firstname: name,
        display_name,
        image: dpURL
      });
    }}
    className={cn({ [styles.profileLink]: true, [className]: className })}
  >

    <div onClick={onClick} style={{ color: 'white' }} className={styles.profileContainer}>
      <div style={{ overflow: 'hidden' }} className={styles.profileImage}>
        {isAccessRequestButton ? (
          <Link
            style={{
              borderRadius: '50%',
              // border: '0.1px solid #707070',
              width: isBelowAccessButton ? '60px' : '85px',
              height: isBelowAccessButton ? '60px' : '85px',
              // padding: '2rem',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden',
              backgroundColor: '#31343E'
            }}
            to={link}
          >
            <img
              className={cn({ [styles.dp]: true, [styles.bottomDp]: isBelowAccessButton })}
              src={newRequestImage || AlterImage}
              alt="Request Access"
              onError={(e) => {
                e.target.src = AlterImage;
              }}
            />
          </Link>
        )
          : isViewMyContent ? (
            <div
              className={`${styles.profileName} ${styles.vewMyContent}`}
            >
              {name}
            </div>
          )
            : !dpURL ? (
              <Link
                style={{
                  borderRadius: '50%',
                  border: '2px solid white',
                  width: '173px',
                  height: '173px',
                  // padding: '2rem',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  overflow: 'hidden'
                }}
                to={link}
              >

                <img
                  className={styles.dp}
                  src={
                    (gender === 'female'
                      ? defaultDpImage_Female
                      : gender === 'male'
                        ? defaultDpImage_Male
                        : gender === 'common'
                          ? PersonIcon
                          : defaultDpImage || AlterImage)
                  }
                  alt={name}
                  onError={(e) => {
                    e.target.src = AlterImage;
                  }}
                />
              </Link>
            ) : (
              <Link
                style={{
                  borderRadius: '50%',
                  border: '2px solid white',
                  width: '173px',
                  height: '173px',
                  // padding: '2rem',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  overflow: 'hidden'
                }}
                to={link}
              >
                <img
                  style={{ width: '100%', height: '100%' }}
                  src={dpURL || AlterImage}
                  onError={(e) => {
                    e.target.src = AlterImage;
                  }}
                />
              </Link>
            )}
      </div>
      {!isViewMyContent ? <div className={cn({ [styles.profileName]: true, [styles.bottomName]: isBelowAccessButton })}>{name}</div> : null}
    </div>
    {id && showRemoveProjectorText && (
      <div
        style={{ color: 'red' }}
        className={cn({
          [styles.profileName]: true,
          [styles.removeProjectorText]: true,
        })}
        onClick={() => {
          // deleteUser();
          setProjectorId(id);
          setProjectorName(name);
          setModalTitle(`Are you sure you want to remove ${name?.trim()}'s projector?`);
          setModal(true);
        }}
      >
        {removeProjectorText}
      </div>
    )}
  </div>
);

ProfileLink.defaultProps = {
  className: undefined,
  dpURL: undefined,
  gender: undefined,
  isAccessRequestButton: false,
  name: undefined
};

ProfileLink.propTypes = {
  className: pt.string,
  dpURL: pt.string,
  gender: pt.string,
  isAccessRequestButton: pt.bool,
  link: pt.string.isRequired,
  name: pt.string
};
const ProfileLinkForDnd = ({
  draggableProvided,
  email,
  lastname,
  setProfileDetails,
  className,
  onClick,
  dpURL,
  gender,
  isAccessRequestButton,
  link,
  name,
  display_name,
  isViewMyContent,
  id,
  setdataOfCategory,
  showRemoveProjectorText,
  setModalTitle,
  setProjectorImage,
  setModal,
  setProjectorOwner,
  setProjectorName,
  setProjectorId,
  removeProjectorText,
  isBelowAccessButton,
}) => (
  <div
    style={{ marginBottom: '15px' }}
    onClick={() => {
      setdataOfCategory && setdataOfCategory();
      setProfileDetails && setProfileDetails({
        firstname: name,
        display_name,
        image: dpURL,
      });
    }}
    className={cn({ [styles.profileLinkDnd]: true, [className]: className })}
  >
    <div onClick={onClick} style={{ color: 'white' }} className={styles.profileContainerDnd}>
      <div className={styles.dragIconContainer} {...draggableProvided.dragHandleProps}>
        <DragIcon className={styles.dragIcon} />
      </div>
      <div style={{ overflow: 'hidden' }} className={styles.profileImage}>

        {isAccessRequestButton ? (
          // Access request button
          (
<Link
            style={{
              borderRadius: '50%',
              width: isBelowAccessButton ? '60px' : '85px',
              height: isBelowAccessButton ? '60px' : '85px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden',
              backgroundColor: '#31343E',
            }}
            to={link}
>
            <img
              className={cn({ [styles.dp]: true, [styles.bottomDp]: isBelowAccessButton })}
              src={newRequestImage || AlterImage}
              alt="Request Access"
              onError={(e) => {
                e.target.src = AlterImage;
              }}
            />
</Link>
)
        ) : isViewMyContent ? (
          // View content
          (
<div className={`${styles.profileNameDnd} ${styles.vewMyContent}`}>
            {name}
</div>
)
        ) : !dpURL ? (
          // Default profile image
          (
<Link
            style={{
              borderRadius: '50%',
              border: '2px solid white',
              width: '100px',
              height: '100px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden',
            }}
            to={link}
>
            <img
              className={styles.dp}
              src={
                gender === 'female'
                  ? defaultDpImage_Female
                  : gender === 'male'
                    ? defaultDpImage_Male
                    : gender === 'common'
                      ? PersonIcon
                      : defaultDpImage || AlterImage
              }
              alt={name}
              onError={(e) => {
                e.target.src = AlterImage;
              }}
            />
</Link>
)
        ) : (
          // Custom profile image
          (
<Link
            style={{
              borderRadius: '50%',
              border: '2px solid white',
              width: '100px',
              height: '100px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden',
            }}
            to={link}
>
            <img
              style={{ width: '100%', height: '100%' }}
              src={dpURL || AlterImage}
              onError={(e) => {
                e.target.src = AlterImage;
              }}
            />
</Link>
)
        )}
      </div>
      {/* Display name, lastname, and email */}
      {!isViewMyContent ? (
        <>
          <div className={cn({ [styles.profileNameDnd]: true, [styles.bottomName]: isBelowAccessButton })}>
            {name}
          </div>
          <div className={cn({ [styles.profileNameDnd]: true, [styles.bottomName]: isBelowAccessButton })}>
            {lastname}
          </div>
          <div className={cn({ [styles.profileNameDnd]: true, [styles.bottomName]: isBelowAccessButton })}>
            {email}
          </div>
        </>
      ) : null}
      {/* Remove projector text */}
      {id && showRemoveProjectorText && (
        <div
          style={{ color: 'red' }}
          className={cn({
            [styles.profileName]: true,
            [styles.removeProjectorText]: true,
          })}
          onClick={() => {
            // deleteUser();
            setProjectorId(id);
            setProjectorName(name);
            setModalTitle(`Are you sure you want to remove ${name?.trim()}'s projector?`);
            setModal(true);
          }}
        >
          {removeProjectorText}
        </div>
      )}
    </div>
  </div>
);
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 6,
    slidesToSlide: 6, // optional, default to 1.
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    slidesToSlide: 3, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  }
};
const isTrueValue = true;

const CustomRightArrow = ({ onClick }) => ((
  <RightArrow
    fontSize="large"
    onClick={onClick}
    aria-label="Go to next slide"
    className={`${styles.customRightArrow} react-multiple-carousel__arrow react-multiple-carousel__arrow--right custom_arrow_profile`}
  />
));

const CustomLeftArrow = ({ onClick }) => ((
  <LeftArrow
    onClick={onClick}
    aria-label="Go to next slide"
    className={`${styles.customLeftArrow} react-multiple-carousel__arrow react-multiple-carousel__arrow--left custom_arrow_profile`}
  />
));

/* Profile-card thumbnail.

   Two very different kinds of image land here: real profile photos (any aspect
   ratio, opaque, large) and the preset avatar badges (Assets/01-12.png and the
   server-side copies of them) — small squares whose art is a rounded badge
   sitting inside a transparent margin. That margin is baked into the stored
   file with a transparency checkerboard, so on the card it read as a grey grid
   frame around the avatar while photos looked fine.

   So: measure the image once it loads and, when it looks like an avatar badge
   (small + square), zoom-crop it (.avatarZoom) so the badge fills the tile and
   the margin is clipped away. Photos are left exactly as they were. */
const AVATAR_MAX_SIDE = 512; // preset avatars are 232px; allow resized copies
const AVATAR_SQUARE_TOLERANCE = 0.02;

/* src -> "is avatar badge art". Module-level on purpose: this row re-renders
   and remounts a few times while /access settles (connections arrive, the
   carousel re-lays out), and a per-instance state would re-classify each time —
   which is what made the zoom visibly snap in after the image had painted. */
const avatarFitCache = new Map();

const isAvatarArtSize = (w, h) => {
  if (!w || !h) return false;
  const isSquare = Math.abs(w - h) <= Math.max(w, h) * AVATAR_SQUARE_TOLERANCE;
  return isSquare && Math.max(w, h) <= AVATAR_MAX_SIDE;
};

const ProfileCardThumb = ({ src, alt }) => {
  const [imgSrc, setImgSrc] = useState(src);
  // null = not classified yet. The <img> is only rendered once this is known,
  // so an un-zoomed frame can never reach the screen.
  const [isAvatarArt, setIsAvatarArt] = useState(
    () => (avatarFitCache.has(src) ? avatarFitCache.get(src) : null)
  );

  useEffect(() => {
    setImgSrc(src);
    if (avatarFitCache.has(src)) {
      setIsAvatarArt(avatarFitCache.get(src));
      return undefined;
    }
    setIsAvatarArt(null);
    // Measure off-DOM. By the time the real <img> mounts the bitmap is in the
    // browser cache, so its first painted frame already carries the right class.
    let alive = true;
    const probe = new Image();
    const settle = (value) => {
      avatarFitCache.set(src, value);
      if (alive) setIsAvatarArt(value);
    };
    probe.onload = () => settle(isAvatarArtSize(probe.naturalWidth, probe.naturalHeight));
    probe.onerror = () => settle(false);
    probe.src = src;
    return () => { alive = false; };
  }, [src]);

  return (
    <div className={styles.profileCardThumb}>
      {isAvatarArt !== null && (
        <img
          src={imgSrc}
          alt={alt}
          className={cn({ [styles.avatarZoom]: isAvatarArt })}
          onError={() => { setImgSrc(AlterImage); }}
        />
      )}
    </div>
  );
};

export const Access = () => {
  const navigate = useNavigate();
  // eslint-disable-next-line no-script-url
  window.location.href = 'javascript: $zopim.livechat.button.show()';
  const defaultSnackbar = { isVisible: false, message: '', type: '' };
  const { userConnections, loadingForAccess, getUserConnections, userDetails,
    langText, setHelpNeed, setdataOfCategory, setNeedToShowETA,
    removeProjectorTextChange, setTopOrBottom, setProfileDetails,
    setProjectorImage, setProjectorOwner, setUserConnections, fetchLayoutOrder, subscriptionDetails,
    mangerToken, userAccessedData } = useContext(AppContext);
  const { getToken, isInActiveUser } = useContext(AuthContext);
  useEffect(() => {
    setTopOrBottom(false);
  }, []);
  useEffect(() => {
    if (!subscriptionDetails || !subscriptionDetails.plans) return;

    const lastPlan = subscriptionDetails.plans[subscriptionDetails.plans.length - 1];

    const shouldRedirect = (
      (isInActiveUser && lastPlan?.is_trial === '0')
      // || subscriptionDetails?.current_plan === 'Free'
      // || subscriptionDetails?.subscription === null
    );

    if (shouldRedirect) {
      navigate('/dashboard');
    }
  }, [isInActiveUser, subscriptionDetails, navigate]);

  const hasId1 = userConnections.some((item) => item.id === '1');
  const [removeProjectorText, setRemoveProjectorText] = useState(false);

  // The floating + button (V2Sidebar's AccessActionsFab, which replaces the
  // bottom dock on this page) fires this event for its "Manage projectors"
  // action — toggle the manage/reorder mode.
  useEffect(() => {
    const toggle = () => setRemoveProjectorText((v) => !v);
    window.addEventListener('access:toggle-manage', toggle);
    return () => window.removeEventListener('access:toggle-manage', toggle);
  }, []);
  const [isOpenModal, setModal] = useState(false);
  const [isOpenPromoModal, setOpenPromoModal] = useState(true);
  const [isOpenMobileModal, setOpenMobileModal] = useState(true);
  const [showIcons, setshowIcons] = useState(true);
  const [modalTitle, setModalTitle] = useState('');
  const [selectedProjectorName, setProjectorName] = useState('');
  const [selectedProjectorId, setProjectorId] = useState(undefined);
  const [snackbarData, setSnackbar] = useState(defaultSnackbar);
  const dashboard = langText?.dashboard;
  const commonText = langText?.common;
  const [showArrow, setArrows] = useState(true);
  const [newOrder, updateNewOrder] = useState();
  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight
  });
  const [response, setResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(undefined);

  const apiUrl = `${baseUrl}/addTutorialsBack`;
  const token = getToken();

  const handlePostRequest = async () => {
    setIsLoading(true);
    try {
      const axiosResponse = await axios.post(apiUrl, { token });

      if (axiosResponse.status === 200) {
        setResponse(axiosResponse.data);
      } else {
        // Handle error, e.g., set an error state
      }
    } catch (error) {
      // Handle network or other errors
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  };

  const callForUpdate = () => {
    const apiUrl = `${baseUrl}/v1/loadUserContents`;
    const postData = {
      token: getToken()
    };
    axios.post(apiUrl, postData)
      .then((response) => response.data)
      .catch((error) => {
        console.error('err', error);
      });
  };

  useEffect(() => {
    // callForUpdate();
    setNeedToShowETA(false);
    setHelpNeed(true);
  }, []);

  const [isBelowAccessButton, setBelowAccessButton] = useState(true);
  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth,
      dynamicHeight: window.innerHeight
    });
  };
  const location = useLocation();

  useEffect(() => {
    window.addEventListener('resize', setDimension);
    return (() => {
      window.removeEventListener('resize', setDimension);
    });
  }, [screenSize]);
  const [carouselKey, setCarouselKey] = useState(0);

  const forceUpdateCarousel = () => {
    // Incrementing the carouselKey value will trigger a re-render of the Carousel
    setCarouselKey((prevKey) => prevKey + 1);
  };
  useEffect(() => {
    if ((screenSize.dynamicWidth <= 767 && userConnections?.length > 1)
      || (screenSize.dynamicWidth >= 768 && screenSize.dynamicWidth <= 1199 && userConnections?.length > 2)
      || (screenSize.dynamicWidth >= 1200 && screenSize.dynamicWidth <= 1440 && userConnections?.length > 3)
      || (screenSize.dynamicWidth >= 1441 && screenSize.dynamicWidth <= 1709 && userConnections?.length >= 4)
      || ((screenSize.dynamicWidth >= 1710 && userConnections?.length > 4))) {
      setArrows(true);
    } else {
      setArrows(false);
    }
    //   if ((screenSize.dynamicWidth >= 768 && screenSize.dynamicWidth <= 1199 && userConnections?.length < 2)
    //   || (screenSize.dynamicWidth >= 1200 && screenSize.dynamicWidth <= 1440 && userConnections?.length < 3)
    //   || (screenSize.dynamicWidth >= 1441 && userConnections?.length < 4)) {
    //     setBelowAccessButton(false);
    //   } else {
    //     setBelowAccessButton(true);
    //   }
  }, [screenSize, userConnections]);

  // useEffect(() => {
  //   const userConnectionFetch = setInterval(() => {
  //     getUserConnections();
  //         }, 30000);
  //   return () => {
  //     clearInterval(userConnectionFetch);
  //   };
  // }, []);

  useEffect(() => {
    setTimeout(() => {
      setOpenPromoModal(true);
    }, 1000);
  }, []);

  const ButtonGroupCarousel = ({ next, previous }) => (
    <ButtonGroup className={styles.customArrowButtonGroup}>
      <CustomRightArrow onClick={next} />
      <CustomLeftArrow onClick={previous} />
    </ButtonGroup>
  );
  const carouselRef = useRef(null);
  const goToFirstSlide = () => {
    if (carouselRef.current) {
      carouselRef.current.goToSlide(0);
    }
  };
  useEffect(() => {
    goToFirstSlide();
  }, [userConnections]);
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };
  const changedItems = {};
  const handleDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const { source, destination } = result;
    const newItems = reorder(userConnections, result.source.index, result.destination.index);
    newItems?.forEach((item, idx) => {
      changedItems[item?.id] = idx + 1;
    });
    if (source.index !== destination.index) {
      updateNewOrder({ items: changedItems });
    }
    const reorderedConnections = userConnections.map((connection) => ({ ...connection }));
    const [removed] = reorderedConnections.splice(source.index, 1);
    reorderedConnections.splice(destination.index, 0, removed);
    setUserConnections(reorderedConnections);
  };
  const [isReorderd, setIsReorderd] = useState(false);
  const reorderApi = async () => {
    setIsReorderd(true);
    try {
      const myToken = await getToken();
      const apiUrl = `${baseUrl}/reorderProjectors`;
      const requestBody = {
        token: myToken,
        items: newOrder?.items
      };
      const response = await axios.post(apiUrl, requestBody);
      // setdata(response.data);
      setIsReorderd(false);
      setRemoveProjectorText(false);
    } catch (error) {
      logAppEvent({
        userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
        functionAffected: 'Reorder Projectors',
        description: 'Projector reorder failed',
        severity: 'medium',
        errorMessage: error?.response?.data?.message || error?.message || 'Projector reorder failed',
        responseStatus: error?.response?.status || null,
        responseBody: error?.response?.data?.message || null,
        requestUrl: `${baseUrl}/reorderProjectors`,
        requestMethod: 'POST',
        component: 'Access',
        userAction: 'Reorder projectors called',
      });
      console.error('Error:', error);
      setRemoveProjectorText(false);
      setIsReorderd(false);
    }
  };
  useEffect(() => {
    fetchLayoutOrder();
  }, []);

  // ---------------------------------------------------------------------------
  // Getting-started checklist
  //
  // This page is where every user lands after logging in or signing up, so the
  // banner lives here rather than on the Content Dashboard. Each entry points at
  // the feature; completion is not derived here — the app POSTs /updateExplored
  // with the section key at the point the action actually succeeds, and
  // userDetails.explored (from /getMyProfile) says which ones are ticked. See
  // Utils/onboardingChecklist.
  // ---------------------------------------------------------------------------
  // "Is a manager driving this session right now" — same test PaymentMethodGate
  // uses. The checklist belongs to the real account owner, so a manager working
  // inside someone else's account never sees it.
  const isManagerImpersonating = !!mangerToken
    || !!userAccessedData
    || localStorage.getItem('isAccessingUser') === 'true';

  const onboardingTasks = useMemo(() => [
    {
      key: EXPLORED_SECTION.upload,
      label: 'Upload',
      hint: 'Add a file',
      icon: <Upload size={19} />,
      onClick: () => { navigate(Pathname.getStoragePath(Pathname.storage.videos)); },
    },
    {
      key: EXPLORED_SECTION.invite,
      label: 'Invite User',
      hint: 'Share access',
      icon: <UserPlus size={19} />,
      onClick: () => { navigate(`${Pathname.dashboard}${Pathname.grantAccess}`); },
    },
    {
      key: EXPLORED_SECTION.rearrange,
      label: 'Rearrange',
      hint: 'Order content',
      icon: <ArrowUpDown size={19} />,
      onClick: () => { navigate(Pathname.contentLayout); },
    },
    {
      key: EXPLORED_SECTION.story,
      label: 'Tell Your Story',
      hint: 'Record a clip',
      icon: <Mic size={19} />,
      onClick: () => { navigate(`${Pathname.giftFlow.content}?autoRecord=true&fromNormalApp=true`); },
    },
    {
      key: EXPLORED_SECTION.addCard,
      label: 'Add Card',
      hint: 'Save a card',
      icon: <CreditCard size={19} />,
      onClick: () => { navigate('/settings/manage-payment-methods?add=true'); },
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
  ], []);

  return (
    <Page
      className={styles.page}
      containerClassName={styles.pageContainer}
      contentClassName={styles.pageContent}
      noBottomBar
      // No bottom dock here — V2Sidebar swaps it for a floating + button whose
      // sheet carries the projector actions (Request new access / Manage
      // projectors) plus the nav destinations.
      accessPageBackGround
    >
      <Box
        aria-hidden
        sx={{ position: 'fixed', inset: 0, zIndex: 0, pointerEvents: 'none' }}
      >
        <SoftAuroraGL
          speed={0.5}
          scale={1.05}
          brightness={1.35}
          color1="#5aa5ef"
          color2="#6d5efc"
          bandHeight={0.5}
          bandSpread={0.5}
          layerOffset={2.5}
          enableMouseInteraction
          mouseInfluence={0.2}
        />
      </Box>
      {!isManagerImpersonating && (
        <Box
          sx={{
            position: 'relative',
            zIndex: 1,
            width: '100%',
            maxWidth: 1160,
            mx: 'auto',
            px: { xs: 2, md: 3 },
            mb: { xs: 2, md: 3 },
            boxSizing: 'border-box',
          }}
        >
          <OnboardingChecklist glass explored={userDetails?.explored} tasks={onboardingTasks} />
        </Box>
      )}
      <div className={styles.access}>
        <div className={styles.message}>
          {dashboard?.title || 'Choose a Projector to View'}
          {/* <>Choose a Projector to view</> */}
          {/* <sp
          n className={styles.messageSpace}>&nbsp;</span>
          <br className={styles.messageBreak} />
          <>to view</> */}
        </div>

        <div
          className={cn({
            [styles.profileLinksContainer]: true,
            [styles[`has${((userConnections?.length + 1) >= 4 ? 4
              : (userConnections?.length + (userDetails.totalContentUploaded > 0 ? 2 : 1)))}Item`]]: true,
            [styles.accessButtonBelow]: isBelowAccessButton
          })}
        >
          {!removeProjectorText
            && (
              <Box
                className={styles.carouselWrapper}
                position="relative"
                sx={{
                  width: '100%', maxWidth: 1120, mx: 'auto', gridColumn: '1 / -1',
                }}
              >
                {!loadingForAccess && (userConnections?.length || userDetails.totalContentUploaded > 0) ? (
                  (() => {
                    // Projector profiles as glass cards in a smooth, damped scroll
                    // row (content-tab card style). "My projector" first, then the
                    // connections. DOM <img> renders cross-origin avatars fine.
                    const galleryItems = [
                      {
                        image: userDetails?.dpURL || defaultDpImage,
                        text: dashboard?.viewProjector || 'My projector',
                        onSelect: () => {
                          if (setdataOfCategory) setdataOfCategory();
                          navigate(Pathname.getProfilePath());
                        },
                      },
                      ...userConnections
                        .filter(({ firstname }) => firstname !== 'Tutorials')
                        .map(({ email, firstname, id, image, display_name }) => ({
                          image: image || AlterImage,
                          text: display_name || firstname || email,
                          onSelect: () => {
                            if (setProfileDetails) setProfileDetails({ firstname, display_name, image });
                            if (setdataOfCategory) setdataOfCategory();
                            navigate(Pathname.getFriendProfilePath(id));
                          },
                        })),
                    ];
                    return (
                      <RowCarousel gap={32} className={styles.profileRow}>
                        {galleryItems.map((it, i) => (
                          <div
                            key={i}
                            role="button"
                            tabIndex={0}
                            className={styles.profileCard}
                            onClick={it.onSelect}
                            onKeyDown={(e) => { if (e.key === 'Enter') it.onSelect(); }}
                          >
                            <ProfileCardThumb src={it.image} alt={it.text} />
                            <span className={styles.profileCardName} title={it.text}>{it.text}</span>
                          </div>
                        ))}
                      </RowCarousel>
                    );
                  })()
                ) : null}
              </Box>
            )}
          {/* Manage projector — remove/undo/save popover (replaces the old
              inline drag-to-remove gallery). Opens when "Manage projectors" is
              pressed (toggles removeProjectorText via the access:toggle-manage
              event). */}
          <ManageProjectorModal
            open={removeProjectorText}
            connections={userConnections}
            onClose={() => setRemoveProjectorText(false)}
            onSaved={getUserConnections}
            setSnackbar={setSnackbar}
          />

          {/* Request access + Manage projectors live in the floating + button's
              sheet (V2Sidebar's AccessActionsFab, onAccessPage). */}
        </div>
        <div className={styles.flexico} />
        {/* Decorative blurred oval removed — it read as an unwanted shadow. */}
      </div>
      <Snackbar {...snackbarData} onClose={() => { setSnackbar({ ...snackbarData, isVisible: false }); }} />
      {
        isOpenModal && (
          <ConfirmationModal
            isVisible={isOpenModal}
            title={`Are you sure you want to remove ${selectedProjectorName}${selectedProjectorName?.trim() !== 'Tutorials' ? "'s projector" : ''}?`}
            onHide={() => { setModal(false); }}
            cancelButton={commonText?.goBack || 'Go Back'}
            continueButton={removeProjectorTextChange ? 'Removing' : 'Remove'}
            content={dashboard?.removeProjectorTitle || 'Once you remove a Projector you will have to request to view again.'}
            id={selectedProjectorId}
            name={selectedProjectorName}
            setSnackbar={setSnackbar}
          />
        )
      }
      {screenSize.dynamicWidth <= 500 && (
        <MobileModal
          isVisible={isOpenMobileModal}
          onHide={() => { setOpenMobileModal(false); }}
          showCloseButton
        />
      )}
      {
        isOpenPromoModal && location.state?.promocode !== undefined
        && location.state?.promocode !== null && (
          <PromotionModal
            isVisible={isOpenPromoModal}
            onHide={() => { setOpenPromoModal(false); }}
            promoCode={location.state?.promocode ? location.state.promocode.promo_code : ''}
            loginCode={location.state?.mobile_token ? location.state.mobile_token : ''}
            showCloseButton
            promoValue={location.state?.promocode ? location.state.promocode.promo_value : '3'}
          />
        )
      }
    </Page>
  );
};
